export function MarkdownGuide() {
  return (
    <div className="text-xs bg-muted p-3 rounded border space-y-1">
      <p className="font-medium">Markdown Quick Reference:</p>
      <ul className="list-disc list-inside space-y-0.5 text-muted-foreground">
        <li><code>**bold**</code> or <code>__bold__</code></li>
        <li><code>*italic*</code> or <code>_italic_</code></li>
        <li><code>[link text](https://url.com)</code></li>
        <li><code>- bullet list</code></li>
        <li><code>1. numbered list</code></li>
        <li><code>&gt; blockquote</code></li>
      </ul>
    </div>
  )
}
